import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './ButtonGroup.css'

const propTypes = {
    children: PropTypes.array,
    buttonsIndent: PropTypes.oneOf(['small', 'large']),
}

const defaultProps = {
    buttonsIndent: 'large',
}

class ButtonGroup extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            maxWidth: null,
        }
        this.childrenRefs = new Array(props.children.length)
    }

    componentDidMount() {
        this.calculateButtonsWidth()
    }

    componentDidUpdate() {
        this.calculateButtonsWidth()
    }

    componentWillReceiveProps(props) {
        this.setState({ maxWidth: null })
        this.childrenRefs = new Array(props.children.length)
    }

    calculateButtonsWidth() {
        let maxWidth = 0
        this.childrenRefs.forEach((ref) => {
            if (ref) {
                maxWidth = Math.max(maxWidth, ref.offsetWidth)
            }
        })
        if (maxWidth > 0 && maxWidth !== this.state.maxWidth) {
            this.setState({ maxWidth })
        }
    }

    refCallback(index, elem) {
        this.childrenRefs[index] = elem
    }

    renderButtons() {
        return this.props.children.map((button, index) => {
            if (button === null) {
                return null
            }

            let key = button.key ? `${button.key}-group-wrapper` : index

            const buttonClassName = classNames(styles.button, styles[`button__${this.props.buttonsIndent}Indent`])

            return (
                <div
                    key={key}
                    style={{width: this.state.maxWidth}}
                    ref={ref => this.refCallback(index, ref)}
                    className={buttonClassName}
                >
                    {button}
                </div>
            )
        })
    }

    render() {
        return (
            <div className={styles.group}>
                {this.renderButtons()}
            </div>
        )
    }
}

ButtonGroup.propTypes = propTypes
ButtonGroup.defaultProps = defaultProps

export default ButtonGroup



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/ButtonGroup/ButtonGroup.jsx